"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCodes = exports.collect = exports.select = void 0;
const Option_1 = require("fp-ts/Option");
const memoize_one_1 = __importDefault(require("memoize-one"));
const types_1 = require("./types");
const function_1 = require("fp-ts/function");
const jst_functions_1 = require("@summer/jst-functions");
/**
 * The bravest are surely those who have the clearest vision of what is before them,
 * glory and danger alike, and yet notwithstanding, go out to meet it.
 */
const applyEvolver = (evolver) => (dictionary) => {
    if (evolver == null) {
        return dictionary;
    }
    if ((0, Option_1.isNone)(dictionary)) {
        return dictionary;
    }
    const evolved = (0, jst_functions_1.mapValues)((a) => {
        if (!(0, types_1.isDictionaryItem)(a)) {
            return a;
        }
        return {
            id: evolver.id ? evolver.id(a.id, a) : a.id,
            code: evolver.code ? evolver.code(a.code, a) : a.code,
            value: evolver.value ? evolver.value(a.value, a) : a.value,
            priority: evolver.priority ? evolver.priority(a.priority, a) : a.priority,
            name: evolver.name ? evolver.name(a.name, a) : a.name,
            items: evolver.items ? evolver.items(a.items, a) : a.items,
            jsonNodeMetaData: evolver.jsonNodeMetaData
                ? evolver.jsonNodeMetaData(a.jsonNodeMetaData, a)
                : a.jsonNodeMetaData,
        };
    }, dictionary.value);
    return (0, Option_1.some)(evolved);
};
const select = (name, evolver) => (0, memoize_one_1.default)(((dictionary) => (0, function_1.pipe)(dictionary[name], Option_1.fromNullable, applyEvolver(evolver))));
exports.select = select;
const collect = (selectFn) => (0, memoize_one_1.default)(((dictionary) => (0, function_1.pipe)(selectFn(dictionary), (0, Option_1.map)((a) => (0, function_1.pipe)(Object.values(a), (b) => b.filter(types_1.isDictionaryItem), (b) => b.slice().sort((c, d) => (c.priority ?? 0) - (d.priority ?? 0)))))));
exports.collect = collect;
const toCodes = (collectFn) => (0, memoize_one_1.default)(((dictionary) => (0, function_1.pipe)(collectFn(dictionary), (0, Option_1.map)((a) => a.map((b) => b.code)))));
exports.toCodes = toCodes;
